import { Component, OnInit } from '@angular/core';
import {FooterComponent} from '../../footer/footer.component';
import {HeaderComponent} from '../../header/header.component';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {Router} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";
import { EnquiryService } from '../../../shared/services/enquiry.service';
import { GlobalService } from '../../../shared/services/global.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertService } from '../../../shared/services/alert.service';

@Component({
  selector: 'vex-features',
  standalone: true,
  imports: [
    FooterComponent,
    HeaderComponent,
    NgClass,
    NgForOf,
    MatIconModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    NgIf,
    ReactiveFormsModule
  ],
  templateUrl: './features.component.html',
  styleUrl: './features.component.scss',
  providers: [EnquiryService, GlobalService]
})
export class FeaturesComponent  implements OnInit {
  addEnquiryForm: FormGroup = new FormGroup({});
  submitted: any = false;
  activeTab: string = 'online_application_management';
  items: {
    icon: string;
    label: string;
    description: string;
  }[] = [
    {
      icon: 'mat:check',
      label: 'Intuitive Interface',
      description:
        'Navigate multiple universities effortlessly through Enroll\'s user-friendly interface designed for seamless interaction and ease of use.'
    },
    {
      icon: 'mat:check',
      label: 'Customizable Dashboards',
      description:
        'Tailor your dashboard to display critical metrics and insights that matter most to your institution\'s admission management process.'
    },
    {
      icon: 'mat:check',
      label: 'Feedback Mechanism',
      description:
        'Engage with stakeholders through built-in feedback tools to continuously improve and adapt Enroll to meet evolving needs.'
    },
    {
      icon: 'mat:check',
      label: 'Accessibility',
      description:
        'Ensure accessibility for all users with Enroll\'s commitment to responsive design and compatibility across devices.'
    },
    {
      icon: 'mat:check',
      label: 'Training and Support',
      description:
        'Empower staff with comprehensive training resources and responsive support to maximize proficiency and resolve queries promptly.'
    },
    {
      icon: 'mat:check',
      label: 'Personalization Options',
      description:
        'Adapt Enroll to fit your institution’s unique workflows and requirements with customizable settings and preferences.'
    },
    {
      icon: 'mat:check',
      label: 'Collaborative Tools',
      description:
        'Foster teamwork and collaboration among admission staff with integrated communication and document-sharing features.'
    },
    {
      icon: 'mat:check',
      label: 'Continuous Updates',
      description:
        'Benefit from regular updates and enhancements that integrate the latest technological advancements and user feedback.'
    },
  ];
  tabs = [
    {
      id: 'online_application_management',
      name: 'Online Application Management',
      title: 'Online Application Management',
      imageSrc: 'assets/images/features-tab-1.png',
      content: 'Say goodbye to paperwork and manual processes. Enroll\'s streamlined application process simplifies and automates every step, from initial submission to final enrollment, saving you time and effort.'
    },
    {
      id: 'documents_management',
      name: 'Documents Management',
      title: 'Documents Management',
      imageSrc: 'assets/images/features-tab-1.png',
      content: 'Enroll effectively manages and stores crucial documents like admission forms, medical records, Identity Cards, and consent forms, ensuring their accessibility and promptness.'

    },
    {
      id: 'applicant_tracking_system',
      name: 'Applicant Tracking System',
      title: 'Applicant Tracking System',
      imageSrc: 'assets/images/features-tab-1.png',
      content: 'Keep tabs on every applicant effortlessly. Enroll\'s dynamic applicant tracking feature allows you to monitor application statuses, track communication history, and generate comprehensive reports with ease.'
    },
    {
      id: 'communication_management',
      name: 'Communication Management',
      title: 'Communication Management',
      imageSrc: 'assets/images/features-tab-1.png',
      content: 'Connect with applicants on a deeper level. Enroll\'s personalized communication tools enable you to send tailored messages, reminders, and updates to each applicant, fostering engagement and enhancing the overall experience.'
    },
    {
      id: 'user_management',
      name: 'User Management',
      title: 'User Management',
      imageSrc: 'assets/images/features-tab-1.png',
      content: 'The system administrator panel allows for various stakeholder roles, including super admin, university admin, and applicants, and ensures secure authentication and authorization mechanisms.'
    },
    {
      id: 'analytics_&_Reporting',
      name: 'Analytics & Reporting',
      title: 'Analytics & Reporting',
      imageSrc: 'assets/images/features-tab-1.png',
      content: 'The system generates reports on application statistics, admission rates, and other relevant data, and provides dashboards for administrators to monitor and analyze system performance.'
    },
    {
      id: 'customization_&_integration',
      name: 'Customization & Integration',
      title: 'Customization & Integration',
      imageSrc: 'assets/images/features-tab-1.png',
      content: 'AMS MI streamlines lead management by seamlessly integrating with various social media platforms. This allows for efficient lead management directly from the platform, providing a comprehensive solution.'
    }
  ];

  selectTab(tabId: string) {
    this.activeTab = tabId;
  }

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private enquiryService: EnquiryService,
              private alertService: AlertService) {
  }
  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.addEnquiryForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
      contact: ['', Validators.required],
      subject: ['', Validators.required]
    });
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }
  submit() {
    this.submitted = true;
    if (!this.addEnquiryForm.valid) {
      return;
    }
    if (this.submitted) {
      const params: {} = {
        'name': (this.addEnquiryForm && this.addEnquiryForm.getRawValue() && this.addEnquiryForm.getRawValue().name) ? this.addEnquiryForm.getRawValue().name : '',
        'email': (this.addEnquiryForm && this.addEnquiryForm.getRawValue() && this.addEnquiryForm.getRawValue().email) ? this.addEnquiryForm.getRawValue().email : '',
        'contact': (this.addEnquiryForm && this.addEnquiryForm.getRawValue() && this.addEnquiryForm.getRawValue().contact) ? this.addEnquiryForm.getRawValue().contact : '',
        'subject': (this.addEnquiryForm && this.addEnquiryForm.getRawValue() && this.addEnquiryForm.getRawValue().subject) ? this.addEnquiryForm.getRawValue().subject : ''
      };
      this.enquiryService.add(params).subscribe(data => {
        this.submitted = false;
        this.addEnquiryForm.reset();
      }, error => {
        this.submitted = false;
        this.alertService.showErrors(error['error']['error']);
      });
    }
  }
}
